module.exports = __webpack_public_path__ + "img/doe-logo-white.e286df47.png";